import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=16ebf516"
import script from "./AppTour.vue?vue&type=script&lang=js"
export * from "./AppTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports